"use client";

import { c as _c } from "react/compiler-runtime";
import { FilterValue } from "@/shared/types/type/search";
import { AllIcon, Typography } from "@/shared/ui/atoms";
import { CustomButton } from "@/shared/ui/molecules";
import { useTranslations } from "next-intl";
import { TREATMENT_ICON_MAP } from "@/shared/constants/icon-map";
interface TreatmentFilterModalBodyProps {
  treatmentList: FilterValue[];
  selectedTreatment: string;
  setSelectedTreatment: (treatment: string) => void;
  hideTreatmentAllOption?: boolean;
}
const TreatmentFilterModalBody = t0 => {
  const $ = _c(19);
  const {
    treatmentList,
    selectedTreatment,
    setSelectedTreatment,
    hideTreatmentAllOption: t1
  } = t0;
  const hideTreatmentAllOption = t1 === undefined ? false : t1;
  const t = useTranslations();
  let t2;
  if ($[0] !== hideTreatmentAllOption || $[1] !== selectedTreatment || $[2] !== setSelectedTreatment) {
    t2 = treatment => {
      if (hideTreatmentAllOption && selectedTreatment === treatment) {
        setSelectedTreatment("");
        return;
      }
      setSelectedTreatment(treatment);
    };
    $[0] = hideTreatmentAllOption;
    $[1] = selectedTreatment;
    $[2] = setSelectedTreatment;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const selectTreatment = t2;
  let t3;
  if ($[4] !== hideTreatmentAllOption || $[5] !== selectTreatment || $[6] !== selectedTreatment || $[7] !== t) {
    t3 = !hideTreatmentAllOption ? <div key="treatment-filter-modal-body-item-All"><CustomButton className="py-[10px] pl-4 flex items-center justify-start gap-1.5" onClick={() => selectTreatment("")}><AllIcon className={selectedTreatment === "" ? "text-primary-600" : "text-gray-400"} size={28} /><Typography size={16} lineHeight={22} className={`${selectedTreatment === "" ? "font-bold text-primary-600" : "text-gray-400"}`}>{t("commonSearch.filter.all")}</Typography></CustomButton></div> : null;
    $[4] = hideTreatmentAllOption;
    $[5] = selectTreatment;
    $[6] = selectedTreatment;
    $[7] = t;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== selectTreatment || $[10] !== selectedTreatment || $[11] !== treatmentList) {
    let t5;
    if ($[13] !== selectTreatment || $[14] !== selectedTreatment) {
      t5 = (item, index) => {
        const IconComponent = TREATMENT_ICON_MAP[item.id as keyof typeof TREATMENT_ICON_MAP];
        const treatmentId = item.id.toString();
        return <div key={`treatment-filter-modal-body-item-${index}`} className="flex justify-start items-center"><CustomButton className="py-[10px] pl-4 flex items-center justify-start gap-1" onClick={() => selectTreatment(treatmentId)}>{IconComponent && <IconComponent className={selectedTreatment === treatmentId ? "text-primary-600" : "text-gray-400"} size={28} />}<Typography size={16} lineHeight={22} className={`text-start ${selectedTreatment === treatmentId ? "font-bold text-primary-600" : "text-gray-400"}`}>{item.name}</Typography></CustomButton></div>;
      };
      $[13] = selectTreatment;
      $[14] = selectedTreatment;
      $[15] = t5;
    } else {
      t5 = $[15];
    }
    t4 = treatmentList.map(t5);
    $[9] = selectTreatment;
    $[10] = selectedTreatment;
    $[11] = treatmentList;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[16] !== t3 || $[17] !== t4) {
    t5 = <div className="grid grid-cols-2 pb-[72px] overflow-y-auto">{t3}{t4}</div>;
    $[16] = t3;
    $[17] = t4;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  return t5;
};
export default TreatmentFilterModalBody;